module.exports = __webpack_public_path__ + "img/senguo_text_logo.5a192311.svg";